(function () {
  var instances = [];

  function initSection(section) {
    var track = section.querySelector('.custom-twi__track');
    var prevBtn = section.querySelector('.custom-twi__nav--prev');
    var nextBtn = section.querySelector('.custom-twi__nav--next');
    if (!track || !prevBtn || !nextBtn) return;

    /* ---- Navigation state ---- */
    function updateNav() {
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    function getScrollAmount() {
      return track.clientWidth;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateNav, { passive: true });
    updateNav();

    /* ---- Drag to scroll ---- */
    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      isDragging = true;
      startX = e.clientX;
      scrollStart = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
      track.style.cursor = 'grabbing';
      track.style.scrollSnapType = 'none';
      track.style.userSelect = 'none';
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      var dx = e.clientX - startX;
      track.scrollLeft = scrollStart - dx;
    });

    function endDrag(e) {
      if (!isDragging) return;
      isDragging = false;
      track.releasePointerCapture(e.pointerId);
      track.style.cursor = '';
      track.style.scrollSnapType = '';
      track.style.userSelect = '';
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    /* Prevent click on links/buttons after drag */
    track.addEventListener('click', function (e) {
      if (Math.abs(track.scrollLeft - scrollStart) > 5) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    /* Store instance for cleanup */
    instances.push({
      section: section
    });
  }

  document.querySelectorAll('.custom-twi').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.custom-twi');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.custom-twi');
    instances = instances.filter(function (inst) {
      return inst.section !== section;
    });
  });
})();
